import { c as _c } from "react/compiler-runtime";
import type { FieldError } from '@onefootprint/core';
import { useRequestError } from '@onefootprint/fetch-hosted/use-request-error';
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';

// The backend scrubs production 500s to this English sentence
const SCRUBBED_SERVER_ERROR = 'Something went wrong';
const useRequestErrorToast = () => {
  const $ = _c(4);
  const {
    toast
  } = useToast();
  const {
    getErrorMessage
  } = useRequestError();
  const {
    t
  } = useTranslation("idv2");
  let t0;
  if ($[0] !== getErrorMessage || $[1] !== t || $[2] !== toast) {
    t0 = (error, t1) => {
      const fieldErrors = t1 === undefined ? [] : t1;
      const fieldMessages = fieldErrors.map(_temp);
      const description = fieldMessages.length > 0 ? fieldMessages.join(", ") : getErrorMessage(error);
      const title = t(_temp2);
      toast({
        description: description === SCRUBBED_SERVER_ERROR ? undefined : description,
        title,
        variant: "error"
      });
    };
    $[0] = getErrorMessage;
    $[1] = t;
    $[2] = toast;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const notify = t0;
  return notify;
};
export default useRequestErrorToast;
function _temp(t0) {
  const {
    message
  } = t0;
  return message;
}
function _temp2($) {
  return $.global.errors["error-toast"].title;
}